import { AbilityBuilder, Ability } from '@casl/ability'
import { offerStatus } from '@/settings/offers'
import { userStatus } from '@/settings/users'
import { roles } from '@/settings/roles'
import userAccess from '@/settings/userAccess'

function subjectName(subject) {
  return !subject || typeof subject === 'string' ? subject : subject.class_name
}

function recruiterAbility(can) {
  can('create', 'Offer')
  can('read', 'Offer')
  can('update', 'Offer', { status: { $in: [offerStatus.draft, offerStatus.published, offerStatus.validated] } })
  can('delete', 'Offer', { status: { $in: [offerStatus.draft, offerStatus.published] } })
  can('duplicate', 'Offer')
  can('share', 'Offer')
  can('cancel', 'Offer', { status: { $in: [offerStatus.validated] } })
  can('update', 'User')
  can('recall', 'User', { state: userStatus.pending })
}

function defineAbilitiesFor(user) {
  return AbilityBuilder.define({ subjectName }, can => {
    switch(user.role){
      case roles.super_admin:
        can('manage', 'all')
        break
      case roles.corporation_admin:
        recruiterAbility(can)
        can('read', userAccess.admin)
        can('manage', 'TimeCode')
        can('delete', 'User', { state: { $in: [userStatus.active, userStatus.pending] },
                                id: { $not: user.id },
                                role: { $not: roles.corporation_admin } })
        can('activate', 'User', { state: userStatus.confirmed })
        can('refuse', 'User', { state: userStatus.confirmed })
        break
      case roles.admin:
        recruiterAbility(can)
        can('read', userAccess.admin)
        can('manage', 'TimeCode')
        can('delete', 'User', { state: { $in: [userStatus.active, userStatus.pending] },
                                id: { $not: user.id },
                                role: { $not: roles.corporation_admin } })
        can('activate', 'User', { state: userStatus.confirmed })
        can('refuse', 'User', { state: userStatus.confirmed })
        break
      case roles.recruiter:
        recruiterAbility(can)
        can('read', userAccess.manager)
        can('wait', 'User', { state: userStatus.confirmed })
        break
      case roles.candidate:
        can('read', userAccess.candidate)
    }
  })
}

export default defineAbilitiesFor



// WEBPACK FOOTER //
// ./src/config/ability.js